let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bW2AP")).then(() => parcelRequire('ch4FS'));